<div *ngIf="form">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">

    <div *ngFor="let field of fields" class="form-row">
      <qm-form-field [field]="field" [form]="form" [horizontal]="horizontal" [titleWidth]="titleWidth"
                     [dataWidth]="dataWidth"></qm-form-field>
    </div>

    <div class="form-row">
      <button type="submit" class="btn btn-primary" [disabled]="!form.valid">{{'Save' | translate}}</button>
    </div>
  </form>
</div>
